export const VALID_GUESSES = [
  'さっぽろ',
  'あおもり',
  'もりおか',
  'せんだい',
  'あきた',
  'やまがた',
  'ふくしま',
  'みと',
  'うつのみ',
  'まえばし',
  'さいたま',
  'ちば',
  'とうきょ',
  'よこはま',
  'にいがた',
  'とやま',
  'かなざわ',
  'ふくい',
  'こうふ',
  'ながの',
  'ぎふ',
  'しずおか',
  'なごや',
  'つ',
  'おおつ',
  'きょうと',
  'おおさか',
  'こうべ',
  'なら',
  'わかやま',
  'とっとり',
  'まつえ',
  'おかやま',
  'ひろしま',
  'やまぐち',
  'とくしま',
  'たかまつ',
  'まつやま',
  'こうち',
  'ふくおか',
  'さが',
  'ながさき',
  'くまもと',
  'おおいた',
  'みやざき',
  'かごしま',
  'なは',
]
